import { interval } from 'rxjs';
import { startWith } from 'rxjs/operators';

import { orderNearDeliveryTimeRemindSubject } from '../../../tasks/subjects';

const POLLING_INTERVAL = 10 * 60 * 1000;

/** 临近送达时间预订单轮询 */
const init = () => {
    interval(POLLING_INTERVAL)
        .pipe(startWith(0))
        .subscribe(() => {
            orderNearDeliveryTimeRemindSubject.next();
        });
};

export default { init };
